var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',{attrs:{"title":_vm.$t('本人確認完了'),"desc":_vm.$t('メールアドレスを確認いたしました。パスワードおよび所属する組織とあなたの情報を入力してください。'),"img":"@/assets/auth/img-signup-verified.png"}},[_c('ProfileForm',{staticClass:"u-mt40",on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }